module.exports = __webpack_public_path__ + "img/produse.05708caa.svg";